module.exports = "<div class=\"gw-action-message__insides\">\r\n    <div class=\"gw-action-message__content\" gw-partial=\"Content\"></div>\r\n    <div class=\"gw-action-message__actions\" gw-partial=\"Action\"></div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/layouts/templates/ActionMessage.html
// module id = 581
// module chunks = 0